const createAuthConfig = () => {
  return {
    headers: {
      "Content-Type": "application/json",
    },
    // This property tells axios to send the httpOnly cookie with the request.
    withCredentials: true,
  };
};

export default createAuthConfig;
